
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/[uid]",
      function () {
        return require("private-next-pages/products/[uid].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/products/[uid]"])
      });
    }
  